/*
 * FalcX buy now (12 Oct 2026)
 *
 * The primary "Buy now" / "Pre-order now" button in blocks/buy-buttons.liquid.
 * - Click: submits the theme's own product form with its Add to cart button as the submitter, so the normal
 *   Horizon add runs (POST /cart/add.js with the selected variant, quantity and the "Pre-order: Yes" line
 *   property, the same cart events and analytics as Add to cart). When that add has gone through, the shopper
 *   is sent to /checkout. If the add fails, the theme shows its usual error and the button comes back.
 * - Variant change: label follows the selected variant ("Pre-order now" when that variant is on backorder,
 *   using the theme's data-falcx-preorder-variants map, "Buy now" otherwise). The button is hidden when the
 *   variant cannot be bought; the theme's "Sold out" / "Unavailable" button stays as it was.
 * Wallet buttons (Shop Pay, Apple Pay, Google Pay, PayPal) are Shopify's and are not touched here.
 */
(function () {
  if (window.__falcxBuyNow) return;
  window.__falcxBuyNow = true;

  var LINES_UPDATE = 'shopify:cart:lines-update';
  var PRODUCT_SELECT = 'shopify:product:select';
  var NO_ADD_TIMEOUT = 8000;

  function isPreorder(pf, id) {
    var data = pf.querySelector('[data-falcx-preorder-variants]');
    if (!data || !id) return false;
    try {
      return JSON.parse(data.textContent || '{}')[String(id)] === true;
    } catch (e) {
      return false;
    }
  }

  function apply(pf, id, available) {
    var wrap = pf.querySelector('[data-falcx-buy-now-wrap]');
    var btn = pf.querySelector('[data-falcx-buy-now]');
    if (!wrap || !btn || btn.getAttribute('aria-busy') === 'true') return;
    wrap.hidden = !available;
    btn.disabled = !available;
    var label = btn.querySelector('[data-falcx-buy-now-label]');
    var text = isPreorder(pf, id) ? btn.dataset.labelPreorder : btn.dataset.labelBuy;
    if (label && text && label.textContent !== text) label.textContent = text;
  }

  document.addEventListener(PRODUCT_SELECT, function (event) {
    var target = event.target;
    if (!(target instanceof Element) || target.closest('product-card')) return;
    var scope = target.closest('.shopify-section, dialog') || document;
    var forms = scope.querySelectorAll('product-form-component');
    if (!forms.length || !event.promise) return;
    Promise.resolve(event.promise)
      .then(function (result) {
        var detail = result && result.detail;
        if (!detail || !detail.html) return;
        // Let the theme's own handler (variant id, pre-order map, Add to cart button) finish first.
        setTimeout(function () {
          forms.forEach(function (pf) {
            if (detail.productId && String(detail.productId) !== String(pf.dataset.productId)) return;
            var resource = detail.resource;
            apply(pf, resource && resource.id != null ? String(resource.id) : '', !!(resource && resource.available));
          });
        }, 0);
      })
      .catch(function () {});
  });

  function buy(btn) {
    if (btn.disabled || btn.getAttribute('aria-busy') === 'true') return;
    var pf = btn.closest('product-form-component');
    var form = pf && pf.querySelector('form');
    var addButton = pf && pf.querySelector('[ref="addToCartButton"]');
    if (!form || !addButton || addButton.disabled) return;
    if (!form.checkValidity()) {
      form.reportValidity();
      return;
    }

    var live = pf.querySelector('[ref="liveRegion"]');
    var done = false;
    var timer;

    function restore() {
      if (done) return;
      done = true;
      clearTimeout(timer);
      document.removeEventListener(LINES_UPDATE, onLinesUpdate, true);
      btn.removeAttribute('aria-busy');
      btn.disabled = false;
    }

    function onLinesUpdate(event) {
      if (event.target !== pf && !(event.target instanceof Node && pf.contains(event.target))) return;
      document.removeEventListener(LINES_UPDATE, onLinesUpdate, true);
      clearTimeout(timer);
      Promise.resolve(event.promise).then(function (result) {
        var detail = result && result.detail;
        if (detail && detail.didError) {
          restore();
          return;
        }
        done = true;
        if (live && btn.dataset.labelBusy) live.textContent = btn.dataset.labelBusy;
        window.location.assign(btn.dataset.checkoutUrl || '/checkout');
      }, restore);
    }

    btn.setAttribute('aria-busy', 'true');
    btn.disabled = true;
    document.addEventListener(LINES_UPDATE, onLinesUpdate, true);
    // The theme starts no add when its own checks stop it (for example a quantity above the maximum).
    timer = setTimeout(restore, NO_ADD_TIMEOUT);

    if (typeof form.requestSubmit === 'function') {
      form.requestSubmit(addButton);
    } else {
      addButton.click();
    }
  }

  document.addEventListener('click', function (event) {
    var btn = event.target instanceof Element ? event.target.closest('[data-falcx-buy-now]') : null;
    if (!btn) return;
    event.preventDefault();
    buy(btn);
  });

  // Back from checkout with the browser's back button: the page can come back from the cache with the button busy.
  window.addEventListener('pageshow', function (event) {
    if (!event.persisted) return;
    document.querySelectorAll('[data-falcx-buy-now][aria-busy="true"]').forEach(function (btn) {
      btn.removeAttribute('aria-busy');
      btn.disabled = false;
    });
  });
})();
